import {useState} from "react";
import styled from 'styled-components';
import {useHistory} from "react-router-dom";

import {Button, FormControl, FormLabel, Input, InputGroup, Stack} from "@chakra-ui/react";
import {Footer, Fullscreen, Main} from '../../components/fullscreen_view';
import Form, {Legal} from "../../components/form";
import useFeedback from "../../utils/use_feedback";
import ErrorMessage from "../../components/error_message";
import {FixedTopBar} from "../../components/top_bar";
import NavLink from "../../components/nav_link";
import {useSignIn} from "../../api/sign_in";
import useToggle from "../../utils/use_toggle";
import {themecolors} from "../../utils/themecolors";

const Note = styled.div``;
const AlternateOption = styled.div``;

const Login = styled(({className}) => {
    const history = useHistory();
    const {feedbackCh, error} = useFeedback(true);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('')
    const [passwordVisibility, togglePasswordVisibility] = useToggle(false);

    const handleUsername = (event) => setUsername(event.target.value)
    const handlePassword = (event) => setPassword(event.target.value)

    const [loading, setLoading] = useState(false);
    const signIn = useSignIn(feedbackCh);
    const handleLogin = async () => {
        setLoading(true);
        try {
            await signIn(username, password);
            history.replace('/');
        } catch {
            // error will be displayed
        }
        setLoading(false);
    }

    return (
        <Fullscreen className={className}>
            <FixedTopBar back border={false} title="Login" />
            <Main>
                <Form autocomplete="off">

                    <Stack spacing={5}>

                        <FormControl>
                            <FormLabel>Username</FormLabel>
                            <Input type="text"
                                   maxLength="24"
                                   autoComplete="off"
                                   required
                                   onChange={handleUsername}
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel>Password</FormLabel>
                            <InputGroup>
                                <Input type={passwordVisibility ? 'text' : 'password'}
                                       maxLength="64"
                                       autoComplete="off"
                                       placeholder={'********'}
                                       required
                                       onChange={handlePassword}
                                />
                                {/* TODO: password visibility toggle button faEye/faEyeSlash) */}
                            </InputGroup>
                        </FormControl>

                    </Stack>

                    <Note>
                        <NavLink href={'/reset'} replace>Forgot your password?</NavLink>
                    </Note>

                </Form>
            </Main>
            <Footer>
                <AlternateOption>
                    {`New user? `}
                    <NavLink href={'/registration'} replace>Create an account.</NavLink>
                </AlternateOption>
                <Button variant={"blue"} width={"100%"} onClick={handleLogin} isLoading={loading}>Login</Button>
                <ErrorMessage error={error}/>
                <Legal>
                    By signing in, you agree to our
                    <a href={'https://help.scored.co/knowledge-base/terms-of-service/'}> Terms of Use</a>,
                    <a href={'https://help.scored.co/knowledge-base/privacy-policy/'}> Privacy Policy</a>, and
                    <a href={'https://help.scored.co/knowledge-base/content-policy/'}> Content Policy</a>.
                </Legal>
            </Footer>
        </Fullscreen>
    );
})`

  ${Form} {
    margin-top: 16px;
  }
  
  ${Footer} {
    width: calc(100% - 42px);
    margin: 0 auto;
  }

  ${Legal} {
    font-size: 13px;
    width: 280px;
    margin: 0 auto;
    margin-top: 12px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Legal} a {
    font-weight: 500;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }

  ${AlternateOption} a {
    font-weight: 600;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }

  ${AlternateOption} {
    font-size: 15px;
    margin-bottom: 16px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Note} {
    margin-top: 8px;
    font-size: 15px;
  }
  ${Note} a {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    font-weight: 400;
  }
`;

export default Login;
